// Utils
import { component } from 'picoapp';
import Swiper, { A11y, Autoplay, Manipulation, Mousewheel, Navigation, Scrollbar } from 'swiper';

import choozy from 'utils/choozy';

Swiper.use([A11y, Autoplay, Navigation, Manipulation, Mousewheel, Scrollbar]);

export default component(async (node) => {
  const { slider } = choozy(node);

  // eslint-disable-next-line
  const carousel = new Swiper(slider, {
    slidesPerView: 1,
    speed: 0,
    loop: true,
    allowTouchMove: false,
    navigation: {
      nextEl: '[data-rotate]',
    },
  });
});
